import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useStore } from "utils/store";
import axios from "axios";
import { getConfig } from "utils/config";
import { useMaintenanceFlagsQuery } from "hooks/queries";
import { MaintenanceUi } from "./MaintenanceUi";

export const Maintenance = () => {
  const { flags } = useMaintenanceFlagsQuery();
  return <MaintenanceUi message={flags?.message} />;
};

export const CheckMaintenance = () => {
  const sessionId = useStore((state) => state.sessionId);
  const { flags } = useMaintenanceFlagsQuery();
  const location = useLocation();
  const navigate = useNavigate();

  const goToMaintenancePage = () => {
    if (!location.pathname.includes("maintenance")) {
      navigate("/maintenance");
    }
  };

  const goToHomePage = () => {
    if (location.pathname.includes("maintenance")) {
      navigate("/");
    }
  };

  useEffect(() => {
    async function checkWhitelist() {
      try {
        const { data } = await axios.get(getConfig("REACT_APP_PROFILE") || "", {
          params: {
            sessionId: sessionId,
          },
        });

        if (flags && flags.enableMaintenance) {
          if (flags.allowedUsers) {
            if (flags.allowedUsers.includes(data.id)) {
              goToHomePage();
            } else {
              goToMaintenancePage();
            }
          } else {
            goToMaintenancePage();
          }
        } else {
          goToHomePage();
        }
      } catch (err: any) {
        console.error(err);
      }
    }

    if (!!sessionId) checkWhitelist();
  }, [flags, location.pathname, navigate, sessionId]);

  return null;
};
